export const uncacheImage = (imgUrl: string): string => {
  // Check if the URL contains 'X-Amz-Signature' indicating it is a pre-signed URL
  if (imgUrl.includes('X-Amz-Signature')) {
    return imgUrl;
  }

  return `${imgUrl}${imgUrl.includes('?') ? '&' : '?'}lastTime=${+new Date()}`;
};
